/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var UnarchiveActionIcon = createIcon("UnarchiveActionIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M17.168 15a5.951 5.951 0 01-10.336 0H3a1.5 1.5 0 00-1.5 1.5V21A1.5 1.5 0 003 22.5h18a1.5 1.5 0 001.5-1.5v-4.5A1.5 1.5 0 0021 15h-3.832ZM12 1.5V12m3.75-7.5L12 1.5l-3.75 3",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});